import { communicationHttpClient } from '#/shared/api/mutators/communication-client'

/**
 * The campaign CSV exports need the bearer header, so a plain `<a href>`
 * cannot fetch them: pull the bytes through the axios client and hand the
 * browser a blob. The generated client types these endpoints as `unknown`
 * and does not ask for a blob, which is why this bypasses it.
 */
export async function downloadCampaignCsv(
  path: string,
  fallbackName: string,
): Promise<void> {
  const response = await communicationHttpClient<Blob>({
    url: path,
    method: 'GET',
    responseType: 'blob',
  })
  const headers: Record<string, unknown> = response.headers
  const disposition = headers['content-disposition']
  const name =
    typeof disposition === 'string'
      ? (parseFilename(disposition) ?? fallbackName)
      : fallbackName
  const url = URL.createObjectURL(response.data)
  try {
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.download = name
    anchor.click()
  } finally {
    URL.revokeObjectURL(url)
  }
}

function parseFilename(disposition: string): string | null {
  const utf8 = /filename\*=UTF-8''([^;]+)/i.exec(disposition)
  if (utf8?.[1] != null) return decodeURIComponent(utf8[1])
  const plain = /filename="?([^";]+)"?/i.exec(disposition)
  return plain?.[1] ?? null
}

export const CAMPAIGN_CSV = {
  people: (campaignId: string) =>
    `/api/v1/campaigns/${campaignId}/people/export`,
  // The export takes the feed's own filter, so what downloads is what is on
  // screen rather than the whole log under a filtered heading.
  activity: (campaignId: string, filter?: string) =>
    `/api/v1/campaigns/${campaignId}/activity/export` +
    (filter == null ? '' : `?filter=${encodeURIComponent(filter)}`),
} as const
